/**
 * The site-role picker for the invite drawers (#241): Reader, Writer or
 * Admin on THIS site. Admin is listed but disabled, with the reason, for a
 * viewer who is not an org admin (the org module refuses it from them).
 * Presentational; the rules live in lib/siteRole.
 */
import { SITE_ROLES, SITE_ROLE_HINT, siteRoleBlockReason, type SiteRole } from '@/lib/siteRole';

export function SiteRoleSelect({
  value,
  onChange,
  viewerIsOrgAdmin,
  disabled,
  label = 'Site role',
}: {
  value: SiteRole;
  onChange: (role: SiteRole) => void;
  viewerIsOrgAdmin: boolean;
  disabled?: boolean;
  label?: string;
}) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize: 12 }}>
      <span className="label-up">{label}</span>
      <select
        className="inp"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value as SiteRole)}
      >
        {SITE_ROLES.map((r) => {
          const blocked = siteRoleBlockReason(r, viewerIsOrgAdmin);
          return (
            <option key={r} value={r} disabled={blocked !== null} title={blocked ?? undefined}>
              {r}
              {blocked ? ' (org admins only)' : ''}
            </option>
          );
        })}
      </select>
      <span style={{ fontSize: 11, color: 'var(--muted)' }}>{SITE_ROLE_HINT[value]}</span>
    </label>
  );
}
